import React from 'react';
import FolderDropdownOption from './FolderDropdownOption/FolderDropdownOption';
import { Icon, ButtonSelect, DropDownMenu } from '@upsales/components';
import BemClass from '@upsales/components/Utils/bemClass';
import FolderTreeBranch from './FolderTreeBranch';
import { FolderTreeType } from '../AccountFiles';
import AddFolderModal from '../FolderModal';
import SearchInput from '../SearchInput';

import './Header.scss';
import { DefaultButton } from '@upsales/components/Buttons';
import { useTranslation } from 'Components/Helpers/translate';

type Props = {
	folders: FolderTreeType[];
	changeFolder: (folderId?: number | null) => void;
	addFolder: (name: string) => void;
	setListMode: (listMode: boolean) => void;
	listMode: boolean;
	addFile: () => void;
	setSearchString: (text: string | null) => void;
	searchString: string | null;
	changeFolderFolder: (id: number, folderId: number | null) => void;
	changeFileFolder: (id: number, folderId: number | null) => void;
	numberOfFiles: number;
	numberOfFolders: number;
};

const Header = ({
	folders,
	changeFolder,
	addFolder,
	setListMode,
	listMode,
	addFile,
	setSearchString,
	searchString,
	changeFolderFolder,
	changeFileFolder,
	numberOfFiles,
	numberOfFolders
}: Props) => {
	const classes = new BemClass('Header');
	const { t } = useTranslation();

	let foldersToShow = folders;
	let foldersDropDown: FolderTreeType[] = [];
	if (folders.length >= 4) {
		foldersToShow = folders.slice(-2);
		foldersDropDown = folders.slice(0, folders.length - 2);
	}

	return (
		<div className={classes.b()}>
			<div className={classes.elem('folder-tree').b()}>
				<FolderTreeBranch
					folder={null}
					changeFolder={changeFolder}
					lastInTree={!folders.length}
					setSearchString={setSearchString}
					searchString={searchString}
					numberOfFolders={numberOfFolders}
					numberOfFiles={numberOfFiles}
					changeFolderFolder={changeFolderFolder}
					changeFileFolder={changeFileFolder}
				/>
				{foldersDropDown.length ? (
					<DropDownMenu
						align="left"
						useAnimation
						noMinWidth
						renderTrigger={(expanded, setExpanded) => (
							<>
								<Icon name="arrow-right" />
								<Icon
									name="ellipsis-h"
									onClick={setExpanded}
									onDragEnter={setExpanded}
									className={classes.elem('folders-dropdown-button').b()}
								/>
							</>
						)}
					>
						<div className={classes.elem('dropdown').b()}>
							{foldersDropDown.map(folder => (
								<FolderDropdownOption
									key={folder.id}
									folder={folder}
									changeFolder={changeFolder}
									changeFolderFolder={changeFolderFolder}
									changeFileFolder={changeFileFolder}
								/>
							))}
						</div>
					</DropDownMenu>
				) : null}
				{foldersToShow.map(folder => (
					<React.Fragment key={folder.id}>
						<Icon name="arrow-right" />
						<FolderTreeBranch
							folder={folder}
							changeFolder={changeFolder}
							lastInTree={folder.id === folders[folders.length - 1].id}
							numberOfFolders={folders.length}
							numberOfFiles={numberOfFiles}
							changeFolderFolder={changeFolderFolder}
							changeFileFolder={changeFileFolder}
						/>
					</React.Fragment>
				))}
			</div>
			<div className={classes.elem('right-container').b()}>
				<SearchInput
					changeFolder={changeFolder}
					setSearchString={setSearchString}
					searchString={searchString}
				/>
				<DefaultButton size="sm" text={t('file.addFile')} icon="file" onClick={addFile} />
				<AddFolderModal
					onClick={name => {
						addFolder(name);
					}}
					clickableComponent={onClick => (
						<DefaultButton size="sm" text={t('file.addFolder')} icon="folder" onClick={onClick} />
					)}
				/>

				<ButtonSelect
					onChange={value => {
						setListMode(value === 2);
						localStorage.setItem('boxViewDocuments', value.toString());
					}}
					options={[
						{
							icon: 'th-large',
							value: 1
						},
						{
							icon: 'th-list',
							value: 2
						}
					]}
					value={listMode ? 2 : 1}
				/>
			</div>
		</div>
	);
};

export default Header;
